<template>
    <div class="wrap is_complete">
        <div class="tbl_inner">
            <div class="tbl_row" :class="{parents: $isIamschoolParent, student: $isIamschoolStudent}">
                <div class="tbl_cell complete_txt_area">
                    <p class="complete_txt">{{ $t(payload.message) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SimpleErrorMessage",

        props: {
            payload: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped>
</style>
